function sizeGuide(centimeterData = []) {
  return {
    centimeter: centimeterData,
    data: [],
    headers: [],
    active: "",
    scrollAmount: 200,

    init() {
      // Extract headers from the first data item
      if (this.centimeter?.length > 0) {
        const firstItem = this.centimeter[0];

        // Transform object keys into headers
        this.headers = Object.keys(firstItem).map((key) => ({
          title: this.formatHeaderTitle(key),
          transformed_title: key
        }));

        // Set initial data to centimeters
        this.active = "cm";
        this.data = this.centimeter;
      }
    },

    formatHeaderTitle(key) {
      // Convert snake_case to Title Case
      return key
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },

    convertToInches(cmValue) {
      // Convert string to number if needed
      const cm = typeof cmValue === "string" ? parseFloat(cmValue) : cmValue;
      // Return empty string if not a valid number
      if (isNaN(cm)) return "";
      // Convert cm to inches (1 cm = 0.393701 inches) and round to 1 decimal
      return (cm * 0.393701).toFixed(1);
    },

    setActive(unit) {
      if (unit === "cm" && this.centimeter?.length > 0) {
        this.active = "cm";
        this.data = this.centimeter;
      } else if (unit === "in" && this.centimeter?.length > 0) {
        this.active = "in";
        // Convert measurements from cm to inches, but keep size unchanged
        this.data = this.centimeter.map((item) => {
          const inchesItem = {};
          Object.entries(item).forEach(([key, value]) => {
            // Keep size field unchanged, convert only measurement fields
            if (key.toLowerCase() === "size") {
              inchesItem[key] = value;
            } else {
              // Only convert numeric values for measurements
              inchesItem[key] = isNaN(value) ? value : this.convertToInches(value);
            }
          });
          return inchesItem;
        });
      }
    },

    scrollLeft() {
      this.$refs.tableContainer?.scrollBy({
        left: -this.scrollAmount,
        behavior: "smooth"
      });
    },

    scrollRight() {
      this.$refs.tableContainer?.scrollBy({
        left: this.scrollAmount,
        behavior: "smooth"
      });
    }
  };
}

export default sizeGuide;
